<div class="dialog-content">
  <app-simple-select [selectionMode]="selectionMode" [selectionEntity]="selectionEntity"
                     [selectedObject]="selectedObject" [selectedObjects]="selectedObjects"
                     [displayedColumns]="displayedColumns" [dialogTitle]="dialogTitle"
                     [excludedId]="excludedId" (selectedObjectOutput)="handleSelectedObjectOutput($event)"></app-simple-select>
  <div>
    <div class="dialog-button-group">
      <button (click)="returnInitialData()" mat-raised-button>
        Abbrechen
      </button>
      <button (click)="closeDialog()" color="primary" mat-raised-button>
        Speichern
      </button>
    </div>
  </div>

</div>
